import { useSelector, } from 'react-redux';
import { IReducerStore, } from '@Store';

const useAbilities = () => {
  return useSelector((store: IReducerStore) => store.abilities);
};

export { useAbilities, };
